<div class="turf-select">
  <div class="d-flex flexWrap-wrap">
    <h3 class="h-02 col__ mt-0075 pb-0050">Assignments</h3>
    <div *ngIf="!selectedResponses?.length"
         class="col__ notif notif--small notif--orange mt-0025 mb-0050">
      User does not have any turf assignments
    </div>
    <div class="col__ mb-0050"
         *ngIf="tagIds.length">
      <mat-list class="ab-list-group ab-list-group--scrollable-border ab-list-group--qb-selected-tags pt-0"
                style="max-height: 200px; overflow-y: auto;">
        <app-tag-list-item *ngFor="let tagId of visibleTagIds"
                           class="ab-list-item bg-color--white p-0"
                           (tagRemoved)="unselectTag(tagId)"
                           [tagId]="tagId"></app-tag-list-item>
        <div class="align-right ab-list-item border-top-0"
             *ngIf="tagIds.length > visibleTagIds.length">
          <button type="button"
                  class="link link--noline"
                  (click)="setVisibleTags()">
            <span>Click To Load More Responses....</span>
          </button>
        </div>
      </mat-list>
    </div>
  </div>
</div>

<app-advanced-response-selector *ngIf="!disabled"
                                [allowSelectAll]="false"
                                [multiple]="true"
                                [targetType]="'EntityType'"
                                [campaignId]="campaignId"
                                [hideUniversal]="true"
                                [resetSelectedFieldOnClose]="true"
                                [resetSelectedTypeOnClose]="true"
                                [selectedResponses]="selectedResponses"
                                (selectedResponsesChange)="onSelectedResponsesChanged($event)">
</app-advanced-response-selector>

<div class="flex flexJustify--between mt-0100 pb-0050">

  <div class="col__ col__md--50">
    <mat-checkbox disableRipple
                  *ngIf="role === 'Activist' || role === 'Organizer' "
                  [formControl]="restrictionEnabledControl"
                  data-test-id="limitAccess">Limit user's view to this assignment</mat-checkbox>
  </div>

  <div class="col__ col__md--50 align-right"
       *ngIf="tagIds?.length > 1">
    <button type="button"
            (click)="removeAllResponses()"
            class="link link--red">Remove All {{tagIds?.length }} Responses</button>
  </div>

</div>
